import { render, staticRenderFns } from "./VehicleTree2.vue?vue&type=template&id=64f5d4f9"
import script from "./VehicleTree2.vue?vue&type=script&lang=js"
export * from "./VehicleTree2.vue?vue&type=script&lang=js"
import style0 from "./VehicleTree2.vue?vue&type=style&index=0&id=64f5d4f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports